import React from 'react';
import RegistrationForm from '../components/RegistrationForm';

export default function Registration(props) {
    return (
        <div class="w-full min-h-max bg-base-background  flex flex-col justify-center items-center">
            <div class="bg-white w-[75%]  p-20 flex  rounded-md">
                <RegistrationForm />
            </div>
        </div>
    );
}
